import { Capacitor, registerPlugin } from '@capacitor/core';

// Нативний плагін (VaillantBridgeViewController.swift / AudioRoutePlugin.java): розмовний динамік чи гучномовець
// фактичний стан аудіосесії після перемикання (iOS; у старих збірках і на Android — порожньо)
export interface AudioRouteInfo {
  outputs?: string;
  category?: string;
  mode?: string;
  options?: number;
  errors?: string[];
}

export interface AudioRoutePlugin {
  setSpeaker(options: { on: boolean }): Promise<AudioRouteInfo | void>;
  reset(): Promise<void>;
}

export const AudioRoute = registerPlugin<AudioRoutePlugin>('AudioRoute');

// у старих збірках зі стору плагіна ще немає
export const isAudioRouteAvailable = () => Capacitor.isPluginAvailable('AudioRoute');
